import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import md5 from 'md5';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { getTempUserIdCookie } from 'commons/localStorage';
import { logError } from 'commons/logger';
import CtaButton from 'components/essentials/Cta/CtaButton';
import focusOnFirstFieldWithError from 'commons/focusOnFirstFieldWithError';
import { EMAIL_REGEX } from 'commons/constants';
import { getRecentlyViewed } from 'components/consumer/cart/utils';
import { LOGIN, FORGOT_PASSWORD, ADD_TO_RECENTLY_VIEWED } from 'mocks/mutations';
import avo from 'analytics/avo';
import { sendAnalyticsIdentifyEvent } from 'commons/analytics';
import useOpenTradeUserSidebar from 'global-state/isTradeUserSidebarOpen/useOpenTradeUserSidebar';
import useSetAuthTokenAndUser from 'data-hooks/useUserData/useSetAuthTokenAndUser';
const LoginForm = t0 => {
  const $ = _c(50);
  const {
    state,
    actions
  } = t0;
  const formRef = useRef();
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [isInvalidPassword, setIsInvalidPassword] = useState(false);
  const [isPasswordEmpty, setIsPasswordEmpty] = useState(false);
  const [, setForgotPasswordError] = useState(null);
  const [addToRecentlyViewed] = useMutation(ADD_TO_RECENTLY_VIEWED);
  const setAuthTokenAndUser = useSetAuthTokenAndUser();
  const openTradeUserSidebar = useOpenTradeUserSidebar();
  let t1;
  if ($[0] !== actions || $[1] !== addToRecentlyViewed || $[2] !== openTradeUserSidebar || $[3] !== setAuthTokenAndUser) {
    t1 = {
      onCompleted: async data => {
        if (!data.login || !data.login.user) {
          if (data.login.errors && (data.login.errors[0]?.field === "email" || data.login.errors[0]?.message?.toLowerCase()?.includes("username") || data.login.errors[0]?.message?.toLowerCase()?.includes("email"))) {
            setIsInvalidEmail(true);
          } else {
            setIsInvalidEmail(false);
          }
          if (data.login.errors && (data.login.errors[0]?.field === "password" || data.login.errors[0]?.message?.toLowerCase()?.includes("password"))) {
            setIsInvalidPassword(true);
          } else {
            setIsInvalidPassword(false);
          }
          focusOnFirstFieldWithError(formRef);
          return null;
        }
        setIsInvalidEmail(false);
        setIsInvalidPassword(false);
        const {
          access_token,
          refresh_token,
          ...user
        } = data.login.user;
        await setAuthTokenAndUser({
          access_token,
          email: user.email,
          first_name: user.first_name,
          group_id: user.group_id,
          id: user.id,
          is_designer: user.is_designer,
          is_impersonate: user.is_impersonate,
          last_name: user.last_name,
          refresh_token,
          user_discount: user.user_discount
        });
        actions.onLogin(user);
        if (actions.onClose) {
          actions.onClose();
        }
        addToRecentlyViewed({
          variables: {
            productIds: getRecentlyViewed()
          }
        });
        if (user.is_designer) {
          openTradeUserSidebar();
        }
        const analyticsUser = {
          customerId: user.id,
          firstName: user.first_name,
          lastName: user.last_name,
          email: user.email,
          hashedEmail: user.email ? md5(user.email) : ""
        };
        sendAnalyticsIdentifyEvent(analyticsUser.customerId.toString(), {
          first_name: analyticsUser.firstName,
          last_name: analyticsUser.lastName,
          email: analyticsUser.email
        });
        avo.loggedIn({
          userId_: analyticsUser.customerId.toString(),
          firstName: analyticsUser.firstName,
          lastName: analyticsUser.lastName,
          hashedEmail: analyticsUser.hashedEmail,
          email: analyticsUser.email
        });
        return null;
      }
    };
    $[0] = actions;
    $[1] = addToRecentlyViewed;
    $[2] = openTradeUserSidebar;
    $[3] = setAuthTokenAndUser;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [login, t2] = useMutation(LOGIN, t1);
  const {
    loading
  } = t2;
  let t3;
  if ($[5] !== actions || $[6] !== setForgotPasswordError) {
    t3 = {
      onCompleted: data_0 => {
        if (!data_0.forgotPassword.success) {
          const rawMessage = data_0.forgotPassword.message;
          let message;
          ;
          try {
            const parsedMsg = JSON.parse(rawMessage);
            message = parsedMsg[0].message;
          } catch (t4) {
            const e = t4;
            logError(e);
            message = e.message;
          }
          setForgotPasswordError(message);
        } else {
          if (actions.onClose) {
            actions.onClose();
          }
        }
      }
    };
    $[5] = actions;
    $[6] = setForgotPasswordError;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [forgotPassword, t4] = useMutation(FORGOT_PASSWORD, t3);
  const {
    loading: forgotPasswordLoading
  } = t4;
  let t5;
  if ($[8] !== state.email) {
    t5 = state.email?.trim() ?? "";
    $[8] = state.email;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const trimmedEmail = t5;
  let t6;
  if ($[10] !== actions || $[11] !== forgotPassword || $[12] !== state.email || $[13] !== trimmedEmail) {
    t6 = async () => {
      if (!state.email) {
        setIsInvalidPassword(true);
        return;
      }
      await forgotPassword({
        variables: {
          email: trimmedEmail
        }
      });
      actions.onForgotPasswordClick(trimmedEmail);
    };
    $[10] = actions;
    $[11] = forgotPassword;
    $[12] = state.email;
    $[13] = trimmedEmail;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const resetPassword = t6;
  let t7;
  if ($[15] !== login || $[16] !== state.password || $[17] !== state.rememberMe || $[18] !== trimmedEmail) {
    t7 = evt => {
      evt.preventDefault();
      evt.stopPropagation();
      const tempUserId = getTempUserIdCookie();
      if (!state.password || state.password === "") {
        setIsPasswordEmpty(true);
        return false;
      }
      setIsPasswordEmpty(false);
      setIsInvalidEmail(false);
      setIsInvalidPassword(false);
      login({
        variables: {
          email: trimmedEmail,
          password: state.password,
          rememberMe: state.rememberMe,
          tempUserId
        }
      });
      return false;
    };
    $[15] = login;
    $[16] = state.password;
    $[17] = state.rememberMe;
    $[18] = trimmedEmail;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const onSubmit = t7;
  const t8 = state.showResetPassword ? "Forgot Password" : "Welcome back!";
  let t9;
  if ($[20] !== t8) {
    t9 = <div className="text-xl font-bold text-gray">{t8}</div>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== actions) {
    t10 = evt_0 => {
      setIsInvalidEmail(false);
      actions.onEmailChange(evt_0);
    };
    $[22] = actions;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = evt_1 => {
      const isEmailValid = EMAIL_REGEX.test(String(evt_1.target.value).toLowerCase());
      setIsInvalidEmail(!isEmailValid);
    };
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  const t12 = isInvalidEmail ? "Email address is invalid" : null;
  let t13;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== trimmedEmail) {
    t13 = <LabeledTextInput name="email" value={trimmedEmail} label="Email address" autoComplete="username" onChange={t10} onBlur={t11} errorMessage={t12} />;
    $[25] = t10;
    $[26] = t12;
    $[27] = trimmedEmail;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== actions.onPasswordChange || $[30] !== isInvalidPassword || $[31] !== isPasswordEmpty || $[32] !== loading || $[33] !== state.password || $[34] !== state.showResetPassword) {
    t14 = !state.showResetPassword && <><LabeledTextInput autoFocus={true} name="password" type="password" label="Password" value={state.password} autoComplete="current-password" onChange={actions.onPasswordChange} errorMessage={isPasswordEmpty ? "Password required" : isInvalidPassword ? "Incorrect password" : null} /><CtaButton type="submit" color="black" styling="solid-button" data-xc="signin-button" disabled={loading} block={true} isLoading={loading}>Continue</CtaButton></>;
    $[29] = actions.onPasswordChange;
    $[30] = isInvalidPassword;
    $[31] = isPasswordEmpty;
    $[32] = loading;
    $[33] = state.password;
    $[34] = state.showResetPassword;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== onSubmit || $[37] !== t13 || $[38] !== t14) {
    t15 = <form method="POST" onSubmit={onSubmit} ref={formRef}>{t13}{t14}</form>;
    $[36] = onSubmit;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  const t16 = !!state.showResetPassword;
  const t17 = state.showResetPassword ? "black" : "brand";
  const t18 = state.showResetPassword ? "solid-button" : "link";
  let t19;
  if ($[40] !== forgotPasswordLoading || $[41] !== resetPassword || $[42] !== t16 || $[43] !== t17 || $[44] !== t18) {
    t19 = <div className="mt-4 text-center"><CtaButton size="sm" hasArrow={false} onClick={resetPassword} disabled={forgotPasswordLoading} block={t16} color={t17} styling={t18} isLoading={forgotPasswordLoading}>Reset Password</CtaButton></div>;
    $[40] = forgotPasswordLoading;
    $[41] = resetPassword;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t15 || $[47] !== t19 || $[48] !== t9) {
    t20 = <div className="text-gray"><div className="consumer-login-form__content">{t9}{t15}{t19}</div></div>;
    $[46] = t15;
    $[47] = t19;
    $[48] = t9;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  return t20;
};
LoginForm.propTypes = {
  state: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    rememberMe: PropTypes.bool,
    showResetPassword: PropTypes.bool
  }),
  actions: PropTypes.shape({
    onEmailChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
    onRememberMeChange: PropTypes.func,
    onForgotPasswordClick: PropTypes.func,
    onClose: PropTypes.func,
    onLogin: PropTypes.func
  })
};
export default LoginForm;